<nb-card>
  <nb-card-header>
    <div>
      <h1>{{ (type === EditType.ADD ? 'additem' : 'edititem') | translate:{value:this.title} }}</h1>
      @if (this.subtitle) {
        <h2>{{ this.subtitle }}</h2>
      }
    </div>
  </nb-card-header>
  <nb-card-body>
    @if (this.form) {
      <form [formGroup]="this.form">
        <table class="edit-table">
          <thead>
          </thead>
          <tbody>
            @for (col of description; track col) {
              <tr>
                <td><label>{{ col.title }}</label></td>
                <td>
                  @if (col.type === ColType.LISTADDER) {
                    <bst-list-adder [target]="col.target || col.name" [addnew]="col.action?.handler" [placeholder]="'enteritem' | translate:{value: col.subtitle ? col.subtitle : col.title}" [formControlName]="col.name" [ngStyle]="col.style" [single]="col.length === 1"></bst-list-adder>
                  }
                  @if (col.type === ColType.STRING && col.length <= 100) {
                    <input type="text" nbInput [maxLength]="col.length" [placeholder]="'enteritem' | translate:{value: col.subtitle ? col.subtitle : col.title}" [formControlName]="col.name" [ngStyle]="col.style">
                  }
                  @if (col.type === ColType.TIME) {
                    <input type="time" nbInput [maxLength]="8" [placeholder]="'hh:mm'" [formControlName]="col.name" [ngStyle]="col.style">
                  }
                  @if ((col.type === ColType.STRING || col.type === ColType.AREA) && col.length > 100) {
                    <textarea nbInput [maxLength]="col.length" [placeholder]="'enteritem' | translate:{value: col.subtitle ? col.subtitle : col.title}" [formControlName]="col.name" [ngStyle]="col.style"></textarea>
                  }
                  @if (col.type === ColType.INT) {
                    <input type="number" nbInput [max]="col.length || 1000" [maxLength]="col.length?.toString().length || 4" [placeholder]="'enternumber' | translate" [formControlName]="col.name" [ngStyle]="col.style">
                  }
                  @if (col.type === ColType.CURRENCY) {
                    <input nbInput currencyMask [options]="Globals.currency" maxlength="7" [placeholder]="'enternumber' | translate" [formControlName]="col.name" [ngStyle]="col.style" class="currency">
                  }
                  @if (col.type === ColType.BOOL) {
                    <nb-checkbox [formControlName]="col.name" [ngStyle]="col.style"></nb-checkbox>
                  }
                  @if (col.type === ColType.DATE) {
                    <input nbInput [placeholder]="'enterdate' | translate" [nbDatepicker]="datepicker" [formControlName]="col.name" [ngStyle]="col.style">
                    <nb-datepicker #datepicker [max]="col.range && col.range.lte ? col.range.lte : undefined" [min]="col.range && col.range.gte ? col.range.gte : undefined"></nb-datepicker>
                  }
                  @if (col.type === ColType.RANGE) {
                    <input nbInput class="input-full-width" [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" [formControlName]="col.name" [ngStyle]="col.style">
                    <nb-rangepicker #rangepicker [max]="col.range && col.range.lte ? col.range.lte : undefined" [min]="col.range && col.range.gte ? col.range.gte : undefined"></nb-rangepicker>
                  }
                  @if (col.type === ColType.RADIO) {
                    <nb-radio-group [name]="col.name" [formControlName]="col.name" [ngStyle]="col.style">
                      @for (r of col.list; track r) {
                        <nb-radio [value]="r.id">{{ r.name }}</nb-radio>
                      }
                    </nb-radio-group>
                  }
                  @if (col.type === ColType.SELECT) {
                    <nb-select [formControlName]="col.name" [placeholder]="'enteritem' | translate:{value: col.title}" [ngStyle]="col.style" [multiple]="col.multiple">
                      @for (r of col.list; track r) {
                        <nb-option [value]="r.id">{{ r.name }}</nb-option>
                      }
                    </nb-select>
                  }
                  @if (col.type === ColType.LOCATION) {
                    <bst-places-editor [formControlName]="col.name" [placeholder]="'enteritem' | translate:{value: col.subtitle ? col.subtitle : col.title}" [style]="col.style"></bst-places-editor>
                  }
                  @if (col.type === ColType.CUSTOM && col.display) {
                    <div>
                      <ng-container [ngTemplateOutlet]="col.display" [ngTemplateOutletContext]="{col:col, form:form.get(col.name), editable:(!this.canEditColumn || this.canEditColumn(col, data, form.get(col.name).value)), fields:form}"></ng-container>
                    </div>
                  }
                  @if (col.hint) {
                    <div class="col-hint">{{ col.hint }}</div>
                  }
                  @if (col.action && col.type === ColType.SELECT) {
                    <button nbButton ghost size="tiny" type="button" class="col-action" (click)="runColAction(col)">{{ col.action.label }}</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </form>
    }
  </nb-card-body>
  <nb-card-footer>
    <button nbButton type="button" (click)="this.cancel()">{{ 'cancel' | translate }}</button>
    <button nbButton type="button" [bstErroring]="form" (bstErroringSuccess)="submit()" status="primary">{{ (type === EditType.ADD ? 'add' : 'save') | translate }}</button>
  </nb-card-footer>
</nb-card>

